import React, { Component } from "react";
//import ReactTable from "react-table"
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import cssu

class Staffs extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteStaffDetail(this.state.propsId);
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchStaffDetails();
          this.setState({ disabled: false });
        },
      },
    ];

    this.state = {
      data: [
        {
          id: "",
          name: "",
          phoneNumber: "",
          emailId: "",
        },
      ],
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      userRoleId: "",
      paginationValue: 10,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  addRow = (data) => {
    var userController = this;
    userController.state.paginationValue =
      userController.state.paginationValue + 5;

    if (userController.state.pageNum != 0) {
      userController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      name: "",
      phoneNumber: "",
      emailId: "",
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    });
  };
  fetchStaffDetails = () => {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/user",

      method: "GET",
      data: {
        userRole: "ADMIN",
        healthSystemId: document.getElementById("healthSystem").value,
        serviceLineId: document.getElementById("serviceLine").value,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchController.state.data = res.result;
          fetchController.setState(fetchController.state);
        } else {
          // fetchController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  saveUserApi(props, e) {
    props.name = document.getElementById("name" + props.index).innerText.trim();
    props.phoneNumber = document
      .getElementById("phoneNumber" + props.index)
      .innerText.trim();
    props.emailId = document
      .getElementById("emailId" + props.index)
      .innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);
    var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
    );
    if (!contactNumberPattern.test(props.phoneNumber)) {
      this.notifyImproperContactNumber();
    }
    var saveData = {
      userName: props.name,
      userPhoneNumber: props.phoneNumber,
      userEmailId: props.emailId,
      userRole: "ADMIN",
      healthSystemId: document.getElementById("healthSystem").value,
      serviceLineId: document.getElementById("serviceLine").value,
    };
    var adduserController = this;
    $.ajax({
      url: "/my-jeeva-api/user",

      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(saveData),
      success: function (res) {
        if (res.success === true) {
          adduserController.notifyAdded();
          adduserController.fetchStaffDetails();
          adduserController.setState({ disabled: false });
        } else {
          adduserController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  updateUserApi(props, e) {
    props.name = document.getElementById("name" + props.index).innerText.trim();
    props.phoneNumber = document
      .getElementById("phoneNumber" + props.index)
      .innerText.trim();
    props.emailId = document
      .getElementById("emailId" + props.index)
      .innerText.trim();

    var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
    );

    if (!contactNumberPattern.test(props.phoneNumber)) {
      this.notifyImproperContactNumber();
    }

    var updatedData = {
      id: props.id,
      userName: props.name,
      userPhoneNumber: props.phoneNumber,
      userEmailId: props.emailId,
      userRole: "ADMIN",
      healthSystemId: document.getElementById("healthSystem").value,
      serviceLineId: document.getElementById("serviceLine").value,
    };
    var updatedDataController = this;
    $.ajax({
      url: "/my-jeeva-api/user",

      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(updatedData),
      contentType: "application/json; charset=UTF-8",
      success: function (res) {
        if (res.success === true) {
          updatedDataController.state.editedId = "-1";
          updatedDataController.notifyUpdate();
          updatedDataController.fetchStaffDetails();
        } else {
          updatedDataController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>There are no admins present. </p>
    </div>
);

  deleteStaffDetail = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-user/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteRowViewController.splice(id, 1);
          } else {
            // deleteRowViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchStaffDetails();
  };
  makeCelledit(props, e) {
    this.markAsBeingEdited(props.id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;User Details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  componentDidMount() {
    var thisController = this;

    setTimeout(() => {
      thisController.fetchHealthSystemDetails();
      thisController.fetchServiceLineDeatils();
      thisController.fetchStaffDetails();
    }, 300);
  }

  refreshData = (id) => {
    var refreshContent = this;
    refreshContent = this.state.editedId = "-1";
    this.setState({ disabled: false });
    this.fetchStaffDetails();
  };

  notifyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;User Detail added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;User detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;All Mlts have been deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperContactNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid contact number
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyNodata(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select the user role
      </b>,
      {
        position: "top-center",
      }
    );
  }

  rolehandleChange = () => {
    let valueOfuserRoleId = document.getElementById("userRole").value;
    this.state.userRoleId = valueOfuserRoleId;

    this.fetchStaffDetails();
  };
  fetchHealthSystemDetails() {
    var fetchController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          responseData = res.result;
          var numberOfuserRoles = responseData.length;
          var ele3 = document.getElementById("healthSystem");
          if (ele3 != "") {
            if (ele3 != null) {
              if (ele3.value != "Select Health System") {
                ele3.innerHTML = "";
              }

              for (var i = 0; i < numberOfuserRoles; i++) {
                ele3.innerHTML =
                  ele3.innerHTML +
                  '<option value="' +
                  responseData[i]["id"] +
                  '">' +
                  responseData[i]["userName"] +
                  "</option>";
              }
            }
          }
        } else {
          fetchController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }
  fetchServiceLineDeatils() {
    var fetchController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          responseData = res.result;
          var numberOfuserRoles = responseData.length;
          var ele3 = document.getElementById("serviceLine");
          if (ele3 != "") {
            if (ele3 != null) {
              if (ele3.value != "Select Service Line") {
                ele3.innerHTML = "";
              }

              for (var i = 0; i < numberOfuserRoles; i++) {
                ele3.innerHTML =
                  ele3.innerHTML +
                  '<option value="' +
                  responseData[i]["id"] +
                  '">' +
                  responseData[i]["userName"] +
                  "</option>";
              }
            }
          }
        } else {
          fetchController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }
  serviceLineHandleChange = () => {
    let valueOfuserRoleId = document.getElementById("serviceLine").value;
    this.state.userRoleId = valueOfuserRoleId;

    this.fetchStaffDetails();
  };
  healthSystemHandleChange = () => {
    let valueOfuserRoleId = document.getElementById("healthSystem").value;
    this.state.userRoleId = valueOfuserRoleId;

    this.fetchStaffDetails();
  };

  openDeletePopUp = (props) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${props.name} ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteStaffDetail(props.id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  render() {
    const { data } = this.state;
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        // accessor: 'name',
        selector: (props) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  props.id == "" || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == "" ? "2px" : "none",
              }}
              id={"name" + props.index}
              contentEditable={
                !(props.id == "" ? false : props.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.userName}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Contact Number</b>,
        // accessor: 'phoneNumber',
        selector: (props) => (
          <div name="phoneNumber">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  props.id == "" || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == "" ? "2px" : "none",
              }}
              id={"phoneNumber" + props.index}
              contentEditable={
                !(props.id == "" ? false : props.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.userPhoneNumber}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Email ID</b>,
        accessor: "emailId",
        selector: (props) => (
          <div name="emailId">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  props.id == "" || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == "" ? "2px" : "none",
              }}
              id={"emailId" + props.index}
              contentEditable={
                !(props.id == "" ? false : props.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.userEmailId}
            </div>
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Action</b>,
        //accessor: 'action',
        width: 200,
        selector: (props) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
            >
              <img
                className="img-responsive"
                // title={(props.id == "") ||
                //     (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  props.id == ""
                    ? this.saveImageSrc
                    : props.id != this.state.editedId
                    ? this.editImageSrc
                    : this.saveImageSrc
                }
                onClick={(e) => {
                  props.id == ""
                    ? this.saveUserApi(props, e)
                    : props.id == this.state.editedId
                    ? this.updateUserApi(props, e)
                    : this.makeCelledit(props, e);
                }}
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
              title="Delete"
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  props.id === ""
                    ? this.fetchStaffDetails()
                    : this.openDeletePopUp(props)
                }
                // this.setState({
                //     hideDeletePopup: true, deletePropIndex: props.index, propsId: props.id
                // })}
              />
            </button>
          </div>
        ),
        width: 100,
      },
    ];
    return (
      <div style={{ marginRight: "1%" }} id="adminTab">
        <div style={{ background: "#F9F9FB" }}>
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          <div className="row" style={{ marginLeft: "3vh" }}>
            <div className="col-sm-10" Align="left">
              <label>Health System</label>
              <select
                id="healthSystem"
                className="healthSystem"
                onChange={this.healthSystemHandleChange}
                placeholder="Select Health System"
                style={{
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              ></select>

              <label style={{ marginLeft: "5vh" }}>Service Line</label>
              <select
                id="serviceLine"
                className="serviceLine"
                onChange={this.serviceLineHandleChange}
                placeholder="Select Service Line"
                style={{
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              ></select>
            </div>

            {/* ---------------------------------------------------------------------------------------------------------- */}
            {/* Add button */}
            <div className="col-sm-2" style={{ marginTop: "-18px" }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2" style={{ marginBottom: "10px" }}>
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disabled
                        ? this.notifyEmptyFieldForAdd
                        : this.addRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginLeft: "15px" }}>
            <div className="col-lg-12 ">
              <div className="card">
                <DataTable
                  // data={data}
                  // columns={columns}
                  // defaultPageSize={10}
                  // pageSizeOptions={[5, 10, 15]}
                  // onPageChange={this.onPageChange}
                  // page={this.state.pageNum}
                  columns={columns}
                  data={this.state.data}
                  pagination={this.state.paginationValue}
                  // pagination={this.state.pageNum}
                  defaultSortFieldName
                  fixedHeaderScrollHeight="400px"
                  noDataComponent={<this.CustomNoDataComponent />}

                />
              </div>
              <ToastContainer className="Toast-at-center" />

              {/* <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog} target='#adminTab'
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;&nbsp;&nbsp;&nbsp;Do you want to delete this User Detail?<br />
                                Note: Press 'Yes' to delete or press 'No' to decline.
                            </DialogComponent> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Staffs;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Admin.js